import { Logo } from '@gds/Logo/Logo';
import { Typography } from '@gds/Typography/Typography';
import { getFormattedDate } from '@intl/GetFormattedDate';

import { VehicleName } from '../VehicleAttributes/VehicleName';
import LeasingPrice from './LeasingPrice/LeasingPrice';
import type { LeasingVehicleAttributesProps } from './LeasingVehicleAttributes.entity';

import vaStyles from '../VehicleAttributes/VehicleAttributes.module.css';
import styles from './LeasingVehicleAttributes.module.css';

export const LeasingVehicleAttributes = ({ vehicle, strings }: LeasingVehicleAttributesProps) => {
  const { prettyName, variant, spec, ukLeasingOptions } = vehicle;

  const leasingPrice = ukLeasingOptions?.[0];

  const term = leasingPrice?.term;
  const annualMileage = leasingPrice?.annualMileage;
  const orderedBy = leasingPrice?.orderedBy;

  return (
    <div className={styles.attributeWrapperSidebar}>
      <VehicleName name={prettyName} variant={variant} spec={spec} />

      <div className={styles.leasingRateWrapper}>
        <div className={vaStyles.priceWrapper}>
          {leasingPrice && <LeasingPrice leasingPrice={leasingPrice} strings={strings} />}
        </div>
      </div>

      <Typography
        className={`${styles.contactDisclaimer} ${vaStyles.smallPrint}`}
        Component="span"
        variant="caption5"
      >
        *{term} {strings.leasingMonths} {annualMileage} {strings.leasingTerms}{' '}
        {strings.leasingOrder} {getFormattedDate(orderedBy)}. {strings.vwfs}
      </Typography>

      <div className={styles.contactTitle}>
        {strings.leasingInterestQuestion}
        <span className={styles.logo}>
          {strings.leasingInterestContact} <Logo usage="light_bg" fontSize={80} />
        </span>
      </div>
    </div>
  );
};
